import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getRavenTransactionTypeDefList = () => get(url.RAVEN_TRANSACTION_TYPE_DEF_GET)
export const addRavenTransactionTypeDef = record => post(url.RAVEN_TRANSACTION_TYPE_DEF_INSERT, record)
export const updateRavenTransactionTypeDef = record => put(url.RAVEN_TRANSACTION_TYPE_DEF_UPDATE, record)
export const deleteRavenTransactionTypeDef = guid => del(url.RAVEN_TRANSACTION_TYPE_DEF_DELETE, { params: { guid } })
